export * from './tabs.interface';
export * from './components/tab.component';
export * from './tabs.component';
export * from './tabs.module';
export * from './tabs.model';
